import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

document.documentElement.classList.add("force-dark");


root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 